import { Component, HostBinding, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import { DadosInscricao } from '../shared/DadosInscricao';
import { FluxoInscricaoService } from '../shared/fluxoInscricao.service';
import { routerTransition } from 'app/shared/animations/router-transition.animation';
import { InscricaoService } from '../shared/inscricao.service';

@Component({
  moduleId: module.id.toString(),
  templateUrl: './curso.component.html',
  styleUrls: ['./curso.component.scss'],
  animations: [routerTransition],
  providers: [
    InscricaoService,
  ],
})
export class CursoComponent implements OnInit  {
  @HostBinding('@routerTransition') routerTransition = true;
  @HostBinding('style.display') display = 'block';

  dadosInscricao: DadosInscricao = new DadosInscricao({});
  dadosInscricaoSubscription: Subscription;

  showAlert = false;
  loading = false;
  cursos: any[] = [];
  cursoSelecionado: any;
  turmas: any;
  turmaSelecionada: any;
  tipo: any;
  tipos = [
    {
      nome: 'Especialização',
      value: 'especializacao',
    },
    {
      nome: 'Mestrado',
      value: 'mestrado',
    },
    {
      nome: 'Doutorado',
      value: 'doutorado',
    },
  ];
  tipoSelecionado: any;
  parcelamentoSelected: any;
  parcelamentos: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fluxoInscricaoService: FluxoInscricaoService,
    private inscricaoService: InscricaoService,
  ) { }

  ngOnInit () {
    this.dadosInscricao = this.fluxoInscricaoService.getDadosInscricao();
    if (Object.keys(this.dadosInscricao).length) {
      this.onChangeTipos();
    }
  }

  onChangeTipos() {
    this.loading = true;
    this.cursoSelecionado = undefined;
    this.turmaSelecionada = undefined;
    this.inscricaoService.getCursos(this.tipoSelecionado.value).subscribe((response) => {
      this.cursos = this.fluxoInscricaoService.preparaCursos(response);
      this.showAlert = this.tipoSelecionado && !this.cursos.length;
      this.loading = false;
    });
  }

  onChangeCursos() {
    this.turmaSelecionada = undefined;
    this.fluxoInscricaoService.setDadosInscricao({ turma: null });
    this.fluxoInscricaoService.resetResumoFluxo();
    this.turmas = this.fluxoInscricaoService.preparaTurmas(this.cursoSelecionado);
  }

  onChangeTurmas() {
    this.fluxoInscricaoService.setDadosInscricao({ turma: this.turmaSelecionada });
    this.parcelamentoSelected = this.fluxoInscricaoService.preparaParcelamento(this.turmaSelecionada);
    this.parcelamentos = this.turmaSelecionada.parcelamento;
  }

  onSave() {
    this.fluxoInscricaoService.proximoPasso({
      tipo: this.tipoSelecionado,
      curso: this.cursoSelecionado,
      turma: this.turmaSelecionada,
      parcelamentoSelected: this.parcelamentoSelected,
      parcelamentos: this.parcelamentos,
    });

    this.nextStep();
  }

  hideAlert() {
    this.showAlert = false;
  }

  nextStep() {
    const proximaRota = this.fluxoInscricaoService.proximaRota();
    this.router.navigate([`../${proximaRota}`], { relativeTo: this.route });
  }

}
